import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetArticleSmallList({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Article/GetSmallList',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetArticleInfo({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Article/Info',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
    GetArticleInfoByTitle({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/Article/InfoByTitle',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/article.js